// The public site talks to the read-only /api/public endpoints. Kept separate
// from src/api (the admin client) because none of these need a token and none
// should ever attach one.
const BASE =
  (process.env.REACT_APP_API_URL || 'http://localhost:5001/api').replace(/\/$/, '') + '/public';

export async function getPublic(path, params = {}) {
  const qs = Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== null && v !== '')
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join('&');

  const res = await fetch(`${BASE}${path}${qs ? `?${qs}` : ''}`);
  if (!res.ok) throw new Error(`Request failed (${res.status})`);
  const data = await res.json();
  return data.results || [];
}

export const todayISO = () => new Date().toISOString().slice(0, 10);

export const fmtDate = (d) => {
  if (!d) return '—';
  const dt = new Date(d);
  return Number.isNaN(dt.getTime())
    ? '—'
    : dt.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
};

// Times are stored as UTC instants; show them in IST, which is what players expect.
export const fmtTime = (d) => {
  if (!d) return '—';
  const dt = new Date(d);
  return Number.isNaN(dt.getTime())
    ? '—'
    : dt.toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit', timeZone: 'Asia/Kolkata' });
};

// True only when the market has actually published something.
export const hasResult = (p, d) =>
  Boolean((p && String(p).trim()) || d === 0 || (d !== '' && d !== undefined && d !== null && String(d).trim()));

export const panna = (p, d) => {
  if (!hasResult(p, d)) return '';
  const a = p || '***';
  const b = d === '' || d === undefined || d === null ? '*' : d;
  return `${a}-${b}`;
};
